import axios from 'axios';
import qs from 'qs';
import { responseHandler } from './response';
import { getToken } from 'common/js/ovoSystem';

axios.defaults.timeout = 300000; //300s超时

/**
 * 普通get请求
 * @param url
 * @param params
 * @returns {*}
 */
export const get = async function(url, params = {}) {
  let res = await axios.get(url, {
    params,
    headers: {
      ticket: getAuthenticator(),
    },
  });
  return responseHandler(res);
};

/**
 * 普通post请求
 * @param url
 * @param params
 * @returns {*}
 */
export const post = async function(url, params = {}) {
  let res = await axios.post(url, qs.stringify(params), {
    headers: {
      ticket: getAuthenticator(),
    },
  });
  return responseHandler(res);
};

/**
 * json格式的Post请求
 * @param url
 * @param params
 * @returns {*}
 */
export const postJson = async function(url, params = {}) {
  let res = await axios.post(url, params, {
    headers: {
      'Content-Type': 'application/json',
      ticket: getAuthenticator(),
    },
  });
  return responseHandler(res);
};

/**
 * 请求头参数规则 token + client + version + language + timezone
 * @returns {string}
 */
function getAuthenticator() {
  return getToken()
  //return 'BCEF32000D485AB21FC1E12E8735F585';
}

// export const exportPDF = async function(url, params, fileName, isExport) {};
